import React, {
    useMemo
} from "react";
import {
    AgGridReact
} from "ag-grid-react";
import aggridUtils
    from "../../../../../utils/aggrid-utils.js";
import {
    DEFAULT_COL_DEF_NO_RESIZE_SUPPRESS_ALL
} from "../../../../../utils/ag-grid-columns-utils.js";
import {
    navigateHook
} from "../../../../../hooks/use-navigate.js";

const GarrisonMaterialCautionTable = ({rows = []}) => {
    const navigate = navigateHook();

    const columnDefs = useMemo(() => [
        {field: "material", headerName: "Material", flex: 2},
        {field: "serial", headerName: "Nº de série", flex: 1},
        {field: "asset", headerName: "Nº de patrimônio", flex: 1},
        {field: "cautionDate", headerName: "Retirada", width: 200, comparator: aggridUtils.agGridCompareDateTime},
        {field: "returnDate", headerName: "Devolução/Baixa", width: 200, comparator: aggridUtils.agGridCompareDateTime},
        {field: "responsibleName", headerName: "Integrante", flex: 2}
    ], []);

    return (
        <AgGridReact
            domLayout="autoHeight"
            rowData={rows}
            columnDefs={columnDefs}
            defaultColDef={DEFAULT_COL_DEF_NO_RESIZE_SUPPRESS_ALL}
            animateRows={false}
            suppressCellFocus={true}
            gridOptions={{localeText: aggridUtils.localization()}}
            theme={aggridUtils.generalTheme()}
            overlayNoRowsTemplate="Nenhum registro."
        />
    );
};

export default GarrisonMaterialCautionTable;
